import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UrlService } from '@src/app/services/url.service';
import { CookieService } from 'ngx-cookie-service';
import { take, tap } from 'rxjs/operators';

@Injectable()
export class AuthenticationService {
  private readonly IS_AUTHENTICATED = 'is_logged_in';

  private cookieService = inject(CookieService);
  private http = inject(HttpClient);
  private url = inject(UrlService);
  private router = inject(Router);

  public isAuthenticated(): boolean {
    return Boolean(this.cookieService.get(this.IS_AUTHENTICATED));
  }

  public logout(): void {
    this.http
      .get<any>(this.url.logout)
      .pipe(
        tap(() => this.router.navigate(['auth'])),
        take(1),
      )
      .subscribe();
  }
}
